import { render } from "./Skill.vue?vue&type=template&id=8246d5ec&ts=true"
import script from "./Skill.vue?vue&type=script&lang=ts"
export * from "./Skill.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__